'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducer = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.default = configureReducer;

var _context = require('./context');

var _context2 = _interopRequireDefault(_context);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** When context has already been created, it can be shared to middleware component. */
var createReducer = exports.createReducer = function createReducer(context) {
  var initialState = context.initialState,
      translateBlueprintTypes = context.translateBlueprintTypes,
      IDLE_STATUSES = context.IDLE_STATUSES;


  var IDLESTATUS_LAST = IDLE_STATUSES.slice(-1)[0];

  var _translateBlueprintTy = translateBlueprintTypes({ START: _constants.START_BLUEPRINT,
    STOP: _constants.STOP_BLUEPRINT,
    GOTO_IDLE_STATUS: _constants.GOTO_IDLE_STATUS_BLUEPRINT,
    ACTIVITY: _constants.ACTIVITY_BLUEPRINT,
    ACTIVITY_DETECTION: _constants.ACTIVITY_DETECTION_BLUEPRINT,
    NEXT_IDLE_STATUS: _constants.NEXT_IDLE_STATUS_BLUEPRINT,
    LAST_IDLE_STATUS: _constants.LAST_IDLE_STATUS_BLUEPRINT
  }),
      START = _translateBlueprintTy.START,
      STOP = _translateBlueprintTy.STOP,
      GOTO_IDLE_STATUS = _translateBlueprintTy.GOTO_IDLE_STATUS,
      ACTIVITY = _translateBlueprintTy.ACTIVITY,
      ACTIVITY_DETECTION = _translateBlueprintTy.ACTIVITY_DETECTION,
      NEXT_IDLE_STATUS = _translateBlueprintTy.NEXT_IDLE_STATUS,
      LAST_IDLE_STATUS = _translateBlueprintTy.LAST_IDLE_STATUS;

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var type = action.type,
        payload = action.payload;

    switch (type) {
      case START:
        return (0, _assign2.default)({}, state, selectStartPayload(payload));
      case STOP:
        return (0, _assign2.default)({}, state, selectStopPayload(payload));
      case GOTO_IDLE_STATUS:
        return (0, _assign2.default)({}, state, selectGotoIdleStatusPayload(payload));
      case ACTIVITY:
        return (0, _assign2.default)({}, state, selectActivityPayload(payload));
      case ACTIVITY_DETECTION:
        return (0, _assign2.default)({}, state, selectActivityDetectionPayload(payload));
      case NEXT_IDLE_STATUS:
        return (0, _assign2.default)({}, state, selectNextIdleStatusPayload(payload));
      case LAST_IDLE_STATUS:
        return (0, _assign2.default)({}, state, selectLastIdleStatusPayload({ lastIdleStatus: IDLESTATUS_LAST }));
      default:
        return state;
    }
  };
};

var selectStartPayload = function selectStartPayload() {
  return { isRunning: true };
};
var selectStopPayload = function selectStopPayload() {
  return { isRunning: false };
};
var selectGotoIdleStatusPayload = function selectGotoIdleStatusPayload(_ref) {
  var idleStatus = _ref.idleStatus;
  return { idleStatus: idleStatus, isIdle: true };
};
var selectActivityPayload = function selectActivityPayload(_ref2) {
  var activeStatus = _ref2.activeStatus,
      lastActive = _ref2.lastActive,
      lastEvent = _ref2.lastEvent,
      timeoutID = _ref2.timeoutID;
  return { idleStatus: activeStatus, lastActive: lastActive, lastEvent: lastEvent, timeoutID: timeoutID, isIdle: false };
};
var selectActivityDetectionPayload = function selectActivityDetectionPayload(_ref3) {
  var isDetectionRunning = _ref3.isDetectionRunning;
  return { isDetectionRunning: isDetectionRunning };
};
var selectNextIdleStatusPayload = function selectNextIdleStatusPayload(_ref4) {
  var nextIdleStatus = _ref4.nextIdleStatus;
  return { idleStatus: nextIdleStatus, isIdle: true };
};
var selectLastIdleStatusPayload = function selectLastIdleStatusPayload(_ref5) {
  var lastIdleStatus = _ref5.lastIdleStatus;
  return { idleStatus: lastIdleStatus, isIdle: true };
};

/** Creates reducer from opts including validation in development */
function configureReducer(opts) {
  return createReducer((0, _context2.default)(opts));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-idle-monitor/lib/reducer.js
// module id = 1227
// module chunks = 16